export default __webpack_public_path__ + "static/media/misc-books3.a84f478c.jpg";